import { Controller } from "@hotwired/stimulus"
import { setCookie, getCookie, deleteCookie } from "../lib/cookie_utils"

export default class extends Controller {
  connect() {
    this.restoreSelection()
  }

  restoreSelection() {
    const saved = getCookie('selected_postal_code')
    if (!saved) return

    try {
      this.element.value = saved
    } catch(e) {
      console.debug('Failed to restore postal code selection:', e)
    }
  }

  change(event) {
    const value = event.target.value?.trim()
    if (!value) {
      // Clear selection
      deleteCookie('selected_postal_code')
      window.location.reload()
      return
    }

    // Validate postal code format (5 digits for Mexican postal codes)
    if (!/^\d{5}$/.test(value)) {
      alert('Por favor ingresa un código postal válido (5 dígitos)')
      event.target.value = ''
      return
    }

    // Save to cookie (expires in 1 year)
    setCookie('selected_postal_code', value, 365)
    // Reload page to apply new location
    window.location.reload()
  }
}
